import moment from 'moment';
import {
  ActionType,
  AutoTextField,
  DatePickerField,
  FormField,
  RadioGroupField,
  SelectAutocompleteField,
  SelectField,
  SelectGroupField,
} from '../../../components/AutoForm/AutoFieldNew';
import {moneyFieldValueType} from '../../../components/AutoForm/AutoFormNew';
import FREQUENCY from '../../../constants/Frequency';
import {OVRecommendActionEnum, BankDetailsEnum} from '../../../schema-types/globalTypes';
import {
  MomentDate,
  initialFeesFieldType,
  builderFieldsType,
} from '../CreateBuilder/builderFields';

export type withdrawalFieldsType = {
  initialFee: initialFeesFieldType;
  destination?: {
    newExistingPotId?: string;
    id: string;
    parentPotId?: string;
    accountNumber?: string;
    sortCode?: string;
    accountName?: string;
    contactId?: string;
    productProvider?: string;
    bankDetails?: BankDetailsEnum | null;
  };
  source: {
    frequency: FREQUENCY;
    maxAmount: number;
    singleClientAmount: moneyFieldValueType;
    recurringClientAmount?: moneyFieldValueType;
    crystallisedFunds?: moneyFieldValueType;
    uncrystallisedFunds?: moneyFieldValueType;
    end?: MomentDate;
    full?: boolean;
    id: string;
    parentPotId?: string;
    reason?: string;
    start?: MomentDate;
    isSaltus: boolean;
  };
};

export const withdrawalAmountField: Omit<AutoTextField, 'id' | 'label'> = {
  type: ActionType.text,
  currency: true,
  decimals: 2,
  placeholder: '0',
  initialValue: '',
  allowZero: true,
  canBeEmpty: true,
};

// COMMENTED OUT — sourcePlan removed from builderFieldsType
// export const withdrawalSourceIdField: FormField = {
//   id: `${PLAN_ACTION.WITHDRAW}.sourcePlan`,
//   label: 'sourcePlan',
//   initialValue: undefined,
//   type: ActionType.text,
// };

export const withdrawalFullField: FormField = {
  id: 'withdraw.source.full',
  label: 'Full redemption?',
  type: ActionType.radioGroup,
  initialValue: false,
  horizontal: true,
  fullWidth: true,
  horizontalOptionWidthXs: 6,
  options: [
    {label: 'Full', value: true},
    {label: 'Partial', value: false},
  ],
};

export const withdrawalAccountStateField: SelectField<
  builderFieldsType,
  BankDetailsEnum
> = {
  id: `withdraw.destination.bankDetails`,
  label: 'Details',
  initialValue: '',
  type: ActionType.select,
  options: [
    {label: 'Account details need validating', value: BankDetailsEnum.NEED_VALIDATING},
    {label: 'Account details not known', value: BankDetailsEnum.NOT_KNOWN},
  ],
};
export const withdrawalProductProviderField: SelectAutocompleteField = {
  id: 'withdraw.destination.productProvider',
  label: 'Bank Name',
  initialValue: '',
  type: ActionType.selectAutocomplete,
  options: [],
};

export const withdrawalAccountNameField: FormField = {
  id: 'withdraw.destination.accountName',
  label: 'Account Name',
  initialValue: '',
  type: ActionType.text,
};
export const withdrawalAccountNumberField: FormField = {
  id: 'withdraw.destination.accountNumber',
  label: 'Account Number',
  labelOnTop: true,
  canBeEmpty: true,
  initialValue: '',
  type: ActionType.text,
};

export const withdrawalFrequencyField: FormField = {
  id: 'withdraw.source.frequency',
  label: 'Frequency',
  type: ActionType.select,
  needsValue: true,

  options: [
    {
      value: FREQUENCY.SINGLE,
      label: 'Single',
    },
    {
      value: FREQUENCY.MONTHLY,
      label: 'Monthly',
    },
    {
      value: FREQUENCY.QUARTERLY,
      label: 'Quarterly',
    },
    {
      value: FREQUENCY.ANNUAL,
      label: 'Annual',
    },
  ],
  initialValue: FREQUENCY.SINGLE,
};

export const withdrawalStartField: FormField = {
  id: 'withdraw.source.start',
  label: 'Start date',
  type: ActionType.datepicker,
  fullWidth: true,
  shouldDisableDate: (day) => {
    const dateMoment = moment.utc(day);
    const date = dateMoment?.get('date');
    if (!date) {
      return true;
    }
    if (date === 1) {
      return false;
    }
    if (date === 15) {
      return false;
    }
    return true;
  },
};
export const withdrawalEndField: FormField = {
  id: 'withdraw.source.end',
  label: 'End date',
  type: ActionType.datepicker,
  fullWidth: true,
  initialValue: undefined,
};

export const withdrawalReasonField: SelectGroupField = {
  id: 'withdraw.source.reason',
  label: 'Withdrawal reason',
  type: ActionType.selectGroup,
  optionGroups: [],
  initialValue: undefined,
};
